import type { ComplexRecordType } from "../stores/agent-store-beta";

export type GenerateDocOps = {
  id: string;
  op: AI_OPS.GENERATE_DOC;
  timestamp: number;
  selection_str: string;
  new_str: string;
  canvas_id: string;
  start_line_number: number;
  end_line_number: number;
};

export type InsertOps = {
  id: string;
  op: AI_OPS.INSERT;
  timestamp: number;
  selection_str: string; // 插入时表示插入在 selection_str 末尾
  new_str: string;
  canvas_id: string;
  start_line_number: number;
  end_line_number: number;
};

export type DeleteOps = {
  id: string;
  op: AI_OPS.DELETE;
  timestamp: number;
  selection_str: string; // 删除时表示删除 selection_str 中的内容
  canvas_id: string;
  start_line_number: number;
  end_line_number: number;
};

export type ReplaceOps = {
  id: string;
  op: AI_OPS.REPLACE;
  timestamp: number;
  selection_str: string; // 替换时表示替换 selection_str 中的内容
  new_str: string;
  canvas_id: string;
  start_line_number: number;
  end_line_number: number;
};

export type ChatAgentOps =
  | [GenerateDocOps]
  | Array<InsertOps | DeleteOps | ReplaceOps>;

export type DocMeta = {
  id: string;
  title: string;
  [k: string]: any;
};

export type ChatAgentCommand<T> = {
  uuid: string;
  command: T;
  doc_meta?: DocMeta;
  doc_id: string;
};

export enum AI_OPS {
  INSERT = 'insert',
  DELETE = 'delete',
  REPLACE = 'replace',
  GENERATE_DOC = 'generate_doc',
}

export interface EditorContentInfo {
  id: string; // page_id,
  meta?: {
    title: string;
  };
  selection: {
    blockIds: string[];
    elementIds: string[];
    markdown: string;
    start_line_number: number;
  };
  document: {
    markdown: string;
  };
}

export type DocTitleCommand = {
  title_new_value: string;
}